export default {
    translation: {
        appName: 'Golanix',
        en: 'English',
        he: 'עברית',
        zh: 'Chinese',
        receivesCertificateEmailZh: 'Receives certificate email',
        login: 'Login',
        logout: 'Logout',
        register: 'Register',
        name: 'Name',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm password',
        sendPasswordResetLink: 'Send Password Reset Link',
        homepage: 'Homepage',
        forgotPassword: 'Forgot password?',
        userNotExistCredentials: 'The specified user does not exist.',
        emailAlreadyExists: 'Email already exists',
        emailHasBeenSent: 'Email has been sent!',
        checkEmailBox: 'Check your email box.',
        emailHasNotBeenSent: 'Email has not been sent!',
        tryAgain: 'Try again.',
        success: 'Success',
        passwordHasBeenChanged: 'Password has been changed',
        error: 'Error',
        resetPassword: 'Reset password',
        notFoundTitle: '404 Page not found',
        notFoundText: 'We couldn`t find the page you`re looking for.',
        profile: 'Profile',
        workspace: 'Workspace',
        quizzes: 'Quizzes',
        id: 'ID',
        actions: 'Actions',
        update: 'Update',
        delete: 'Delete',
        numberOfQuestions: 'Number of questions',
        dateOfCreation: 'Date of creation',
        addQuiz: 'Add quiz',
        add: 'Add',
        titleEn: 'Title EN',
        titleHe: 'Title HE',
        updateQuiz: 'Update quiz',
        questions: 'Questions',
        addQuestion: 'Add question',
        updateQuestion: 'Update question',
        taskTitle: 'Task title',
        hintTitle: 'Hint title',
        titleTaskEn: 'Task title EN',
        titleTaskHe: 'Task title HE',
        titleHintEn: 'Task title EN',
        hintEn: 'Hint EN',
        hintHe: 'Hint HE',
        choiceQuestion: 'Choice question',
        pictureQuestion: 'Picture question',
        answer: 'Answer',
        right: 'Right',
        search: 'Search',
        resetFilters: 'Reset filters',
        searchFor: 'Search for',
        dateFrom: 'Date from',
        dateTo: 'Date to',
        courses: 'Courses',
        addCourse: 'Add course',
        addLesson: 'Add lesson',
        chooseFile: 'Choose file',
        picturesShouldBeFive: 'Pictures should be five',
        courseName: 'Course name',
        course: 'Course',
        certificate: 'Certificate',
        certificates: 'Certificates',
        description: 'Description',
        dragPicturesNotification: 'The number at the top of the picture shows the correct sequence. You can move pictures to change the rendering for the user. Use <i class=\'fas fa-cloud-upload-alt\'></i> to replace the picture.',
        chooseImage: 'Choose image',
        courseImage: 'Course image',
        certificateImage: 'Certificate image',
        certificateImageIsRequired: 'Certificate image is required',
        courseImageIsRequired: 'Course image is required',
        addCertificate: 'Add certificate',
        courseCertificate: 'Course certificate',
        title: 'Title',
        titleTask: 'Title task',
        hint: 'Hint',
        questionsOrder: 'Questions order',
        dragInTheDesiredSequence: 'Drag in the desired sequence',
        users: 'Users',
        schoolManager: 'School Manager',
        schoolManagers: 'School Managers',
        teacher: 'Teacher',
        teachers: 'Teachers',
        student: 'Student',
        students: 'Students',
        managersList: 'School Managers List',
        teachersList: 'Teachers List',
        country: 'Country',
        createManager: 'Create School Manager',
        updateManager: 'Update School Manager',
        createTeacher: 'Create Teacher',
        updateTeacher: 'Update Teacher',
        createStudent: 'Create Student',
        updateStudent: 'Update Student',
        send: 'Send',
        create: 'Create',
        createManagerSuccess: 'School Manager was created',
        createTeacherSuccess: 'Teacher was created',
        createStudentSuccess: 'Student was created',
        updateManagerSuccess: 'School Manager was updated',
        updateTeacherSuccess: 'Teacher was updated',
        updateStudentSuccess: 'Student was updated',
        deleteManagerSuccess: 'School Manager was deleted',
        deleteTeacherSuccess: 'Teacher was deleted',
        deleteStudentSuccess: 'Student was deleted',
        emptyString: '',
        createSchool: 'Create School',
        updateSchool: 'Update School',
        createSchoolSuccess: 'School was created',
        updateSchoolSuccess: 'School was updated',
        deleteSchoolSuccess: 'School was deleted',
        schoolsList: 'School List',
        schools: 'Schools',
        address: 'Address',
        serial: 'Serial',
        subscriptionStartDate: 'Subscription Start Date',
        subscriptionPeriod: 'Subscription Period',
        studentLicences: 'Student Licences',
        teacherLicences: 'Teacher Licences',
        schoolManagersList: 'School Managers List',
        enabled: 'Enabled',
        studentsList: 'Students List',
        username: 'Username',
        school: 'School',
        optional: 'Optional',
        teacherLimit: 'Max teachers limit',
        studentLimit: 'Max students limit',
        certificateName: 'Certificate name',
        prerequisiteCourses: 'Prerequisite courses',
        certificateDescription: 'Certificate description',
        courseDescription: 'Course description',
        updateCourse: 'Update course',
        courseManagement: 'Course Management',
        lessons: 'Lessons',
        lesson: 'Lesson',
        lessonName: 'Lesson Name',
        lessonDescription: 'Lesson description',
        lessonImage: 'Lesson image',
        badge: 'Badge',
        badges: 'Badges',
        badgeName: 'Badge Name',
        badgeDescription: 'Badge description',
        badgeImage: 'Badge image',
        numberOfDaysAfterWhichLessonBeAvailable: 'Number of days after which a lesson gets to be available for Student',
        createLessonBadge: 'Create lesson badge',
        updateLesson: 'Update lesson',
        userSchoolIsBlocked: 'User school is blocked',
        disabled: 'Disabled',
        userDisabled: 'User disabled',
        userStatus: 'User Status',
        filterByUserStatus: 'Filter by user status',
        locked: 'Locked',
        unlocked: 'Unlocked',
        courseLessons: 'Course lessons',
        lessonsOfThisCourse: 'Lessons of this course',
        status: 'Status',
        select: 'Select',
        courseStatusUpdated: 'Course status updated',
        lessonStatusUpdated: 'Lesson status updated',
        numberOfLessons: 'Number of lessons',
        topics: 'Topics',
        topic: 'Topic',
        addTopic: 'Add topic',
        topicName: 'Topic name',
        topicImage: 'Topic image',
        topicDescription: 'Topic description',
        linkForVideo: 'Video link',
        topicContent: 'Topic content',
        minimumTimeRequiredForTimeCounter: 'Minimum time required for time counter (minute)',
        topicStatusUpdated: 'Topic status updated',
        updateTopic: 'Update topic',
        numberOfTopics: 'Number of topics',
        lessonTopics: 'Lesson topics',
        numberOfQuizzes: 'Number of quizzes',
        topicQuizzes: 'Topic quizzes',
        studentAssigned: 'Student assigned',
        studentReassigned: 'Student reassigned',
        selectedCourses: 'Selected courses',
        courseTitle: 'Course title',
        unsubscribe: 'Unsubscribe',
        assign: 'Assign',
        assignToCourse: 'Assign to course',
        topicFiles: 'Topic files',
        uploadXML: 'Upload XML',
        show: 'Show',
        ok: 'Ok',
        createdAt: 'Created at',
        lockUnlock: 'Lock/Unlock',
        lock: 'Lock',
        unlock: 'Unlock',
        studentStarted: 'Student Started',
        studentFinished: 'Student Finished',
        studentDeleted: 'Student Deleted',
        teacherActive: 'Teacher Active',
        teacherInactive: 'Teacher Inactive',
        attention: 'Attention',
        thisUserHasBeenDisabled: 'This user has been disabled',
        trackProgress: 'Track progress',
        progress: 'Progress',
        userName: 'User name',
        studentName: 'Student name',
        topicQuiz: 'Topic / Quiz',
        quiz: 'Quiz',
        courseNotHaveLessons: 'Course does not have lessons',
        adManagement: 'Ad Management',
        ads: 'Ads',
        addAd: 'Add ad',
        adDescription: 'Ad description',
        adImage: 'Ad Image',
        ad: 'Ad',
        link: 'Link',
        linkWithProtocol: 'Link with protocol (http:// or https: //)',
        updateAd: 'Update ad',
        countGuestClick: 'Count guest click',
        adNewsManagement: 'Ad / News Management',
        news: 'News',
        addNews: 'Add news',
        updateNews: 'Update news',
        newsDescription: 'News description',
        newsImage: 'News image',
        countLoginUsersClick: 'Count login users click',
        details: 'Details',
        user: 'User',
        date: 'Date',
        sitePlaces: 'Place where to show ad',
        schoolCourses: 'School courses',
        emailTemplates: 'Email Templates',
        receivesBadge: 'Receives Badge',
        receivesBadgeEmail: 'Receives Badge Email',
        receivesBadgeEmailEn: 'Receives Badge Email (English)',
        receivesBadgeEmailHe: 'Receives Badge Email (Hebrew)',
        receivesCertificate: 'Receives Certificate',
        receivesCertificateEmail: 'Receives Certificate Email',
        receivesCertificateEmailEn: 'Receives Certificate Email (English)',
        receivesCertificateEmailHe: 'Receives Certificate Email (Hebrew)',
        hello: 'Hello!',
        helloUser: 'Hello, <user>!',
        regards: 'Regards,',
        footerEmailText: '© 2018 Golanix. All rights reserved.',
        enrollsCourse: 'Course Enrolls',
        enrollsCourseEn: 'Course Enrolls (English)',
        enrollsCourseHe: 'Course Enrolls (Hebrew)',
        templateUpdated: 'Template updated',
        countClick: 'Count click',
        needToCreateStudent: 'First you need to create student',
        back: 'Back',
        cancel: 'Cancel',
        searchStudentList: 'Name, username, country, school',
        searchManagerList: 'Name, country, school',
        searchTeacherList: 'Name, country, school',
        searchCoursesList: 'Title',
        searchLessonsList: 'Title, course',
        searchTopicsList: 'Task, lesson, course',
        searchQuizList: 'Course, lesson, topic, title',
        searchQuestionList: 'Quiz, course, lesson, topic',
        showPrivateUsers: 'Show private users',
        clear: 'Clear',
        requireFieldLabel: '<span class="required-form-field"> *</span>',
        duplicateLesson: 'Duplicate lesson',
        finishCourseMainText: 'Congratulations! You have just received the certificate <strong>&lt;Certificate name&gt;</strong> in your course <strong>&lt;Course name&gt;</strong>',
        finishCourseMainTextEn: 'Congratulations! You have just received the certificate <strong>&lt;Certificate name&gt;</strong> in your course <strong>&lt;Course name&gt;</strong>',
        finishCourseMainTextHe: 'Congratulations! You have just received the certificate <strong>&lt;Certificate name&gt;</strong> in your course <strong>&lt;Course name&gt;</strong>',
        finishLessonMainText: 'Congratulations! You have just received the badge <strong>&lt;Badge name&gt;</strong> in your course <strong>&lt;Course name&gt;</strong>',
        finishLessonMainTextEn: 'Congratulations! You have just received the badge <strong>&lt;Badge name&gt;</strong> in your course <strong>&lt;Course name&gt;</strong>',
        finishLessonMainTextHe: 'Congratulations! You have just received the badge <strong>&lt;Badge name&gt;</strong> in your course <strong>&lt;Course name&gt;</strong>',
        startCourseMainText: 'You have enrolled to the <strong>&lt;Course name&gt;</strong>',
        startCourseMainTextEn: 'You have enrolled to the <strong>&lt;Course name&gt;</strong>',
        startCourseMainTextHe: 'You have enrolled to the <strong>&lt;Course name&gt;</strong>',
        startCourseSecondaryText: 'Subscription will end at &lt;Period&gt;',
        startCourseSecondaryTextEn: 'Subscription will end at &lt;Period&gt;',
        startCourseSecondaryTextHe: 'Subscription will end at &lt;Period&gt;',
        certificateCourse: 'Certificate, course',
        badgeLessonCourse: 'Badge, lesson, course',
        image: 'Image',
        programmingMissions: 'Programming Missions',
        topicLessonCourse: 'Topic, lesson, course',
        reset: 'Reset',
        selectCourse: 'Select course',
        selectLesson: 'Select lesson',
        shortCourseDescription: 'Short course description',
        shortLessonDescription: 'Short lesson description',
        shortTopicDescription: 'Short topic description',
        numberOfHours: 'Number of hours',
        toggle: 'Toggle',
        skills: 'Skills',
        defaultLanguage: 'Default language',
        language: 'Language',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        startDate: 'Start date',
        endDate: 'End date',
        default: 'Default',
        order: 'Order',
        courseMap: 'Course map',
        courseMapZip: 'CourseMap.zip',
        missionDescription: 'Mission description',
        missionTitle: 'Mission title',
        requiredField: 'Field required',
        courseLanguage: 'Course language',
        newsTitle: 'News title',
        mission: 'Mission',
        selectLanguage: 'Select language',
        selectCountry: 'Select country',
        duplicateComplete: 'Duplicate completed',
        smsGoesWrong: 'Something goes wrong',
        changePassword: 'Change password',
        passwordNotMatch: 'Passwords do not match',
    },
};



// WEBPACK FOOTER //
// ./src/lang/en/en.js